import React, { Component } from "react";
import ReactPaginate from "react-paginate";
import { Table, Card, Row, Col, Image } from "react-bootstrap";
import ExpiryReturnsView from "./ExpiryReturnsView";
var dateFormat = require("dateformat");

class ExpiryReturns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ExpiryReturnsShow: false,
      page: 0,
      perPage: 10,
      Spage: 0,
      perPageS: 10,
      searchExpiryReturns: "",
      searchShow: false,
      perPagef: 10,
      FltrPage: 0,
      filterValue: "All",
      FilterTable: false
    };
  }

  componentDidMount() {
    this.props.ExpiryReturn();
  }

  handleExpiryReturnsView = (item) => {
    this.setState({
      ExpiryReturnsShow: true,
      ExpiryReturnsDtls: item
    });
    this.props.ExpiryReturnView(item);
  };

  handleCloseExpiryReturnsView = () => {
    this.setState({ ExpiryReturnsShow: false });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.ExpiryReturnsSelectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };

  handlePageSearchClick = (e) => {
    const selectedSearchPage = e.selected;
    this.setState({ Spage: selectedSearchPage });

    this.props.ExpiryReturnsSearchSelectedPage({
      Spage: selectedSearchPage + 1,
      ExpiryReturns: this.state.searchExpiryReturns
    });
  };

  SearchOnChange = (event) => {
    const ExpiryReturns = event.target.value;

    this.setState({
      searchShow: true,
      FilterTable: false,
      filterValue: "All",
      searchExpiryReturns: ExpiryReturns
    });

    this.props.ExpiryReturnsSearch({
      Spage: this.state.Spage + 1,
      ExpiryReturns
    });
  };

  handleChange = (event) => {
    this.setState({
      FltrPage: 0,
      filterValue: event.target.value,
      searchExpiryReturns: ""
    });

    if (event.target.value === "All") {
      this.setState({
        FilterTable: false,
        searchShow: false
      });
    } else {
      this.props.FilterSearchExpiryUser({
        page: 1,
        value: event.target.value
      });
      this.setState({ FilterTable: true });
    }
  };

  handlePageFltrClick = (e) => {
    const selectedFltrPage = e.selected;
    this.setState({ FltrPage: selectedFltrPage });

    this.props.fltrExpiryUserPagetn({
      page: selectedFltrPage + 1,
      value: this.state.filterValue
    });
  };

  render() {
    const p = this.state.page + 1;
    const count = this.props.ExpiryReturnlsCount;
    const pageCount = Math.ceil(count / this.state.perPage);

    const p2 = this.state.Spage + 1;
    const searchCount = this.props.ExpiryReturnSearchCount;
    const searchPageCount = Math.ceil(searchCount / this.state.perPageS);

    const p3 = this.state.FltrPage + 1;
    const fltrCount = this.props.expiryUserFilterCount;
    const fltrPageCount = Math.ceil(fltrCount / this.state.perPagef);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col md={3}>
                <h3>Expiry Returns</h3>
              </Col>

              <Col md={3}>
                <select
                  value={this.state.filterValue}
                  onChange={this.handleChange}
                  className="commonFilterSelect"
                >
                  <option value="All">All</option>
                  <option value="created">Created</option>
                  <option value="accepted">Accepted</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </Col>

              <Col md={3}>
                <div className="commonInput">
                  <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                  <input
                    type="text"
                    placeholder="Search by Order Id/Name"
                    value={this.state.searchExpiryReturns}
                    onChange={this.SearchOnChange}
                  />
                </div>
              </Col>

              <Col md={3}>
                <div className="commonRecrd">
                  <span className="cmnPageCount">
                    {!this.state.searchShow &&
                      !this.state.FilterTable &&
                      count}
                    {this.state.searchShow &&
                      !this.state.FilterTable &&
                      searchCount}
                    {this.state.FilterTable && fltrCount}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>

          <Card.Body>
            <Table responsive bordered striped className="cmnMainTable">
              <thead>
                <tr className="cmnMainTableHd">
                  <th>SL NO</th>
                  <th>ORDER ID</th>
                  <th>CHEMIST NAME</th>
                  <th>DISTRIBUTOR NAME</th>
                  <th>CREATED DATE</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {(this.state.FilterTable
                  ? this.props.expiryUserFilterList
                  : this.state.searchShow
                  ? this.props.ExpiryReturnSearchList
                  : this.props.ExpiryReturnDtlsList
                )?.map((item, i) => (
                  <tr key={i}>
                    <td>{10 * ((this.state.FilterTable ? p3 : this.state.searchShow ? p2 : p) - 1) + i + 1}</td>
                    <td>{item.orderNo}</td>
                    <td>{item.chmstDtls?.name}</td>
                    <td>{item.dstbtrDtls?.name}</td>
                    <td>
                      {item.createdAt &&
                        dateFormat(item.createdAt, "dd-mmm-yyyy, h:MM TT")}
                    </td>
                    <td>{item.status}</td>
                    <td className="cmnViewIcon">
                      <i
                        className="fa fa-eye fa-lg"
                        onClick={() =>
                          this.handleExpiryReturnsView({ item })
                        }
                      ></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <ExpiryReturnsView
              show={this.state.ExpiryReturnsShow}
              handleClose={this.handleCloseExpiryReturnsView}
              ProductReturnsDtls={this.state.ExpiryReturnsDtls}
              ProductReturnls={this.props.ExpiryReturnls}
              ProductReturnDtlsCount={this.props.ExpiryReturnDtlsCount}
            />
          </Card.Body>

          {!this.state.searchShow &&
            !this.state.FilterTable &&
            pageCount > 1 && (
              <ReactPaginate
                forcePage={this.state.page}
                pageCount={pageCount}
                onPageChange={this.handlePageClick}
                containerClassName="pagination"
                activeClassName="active"
              />
            )}

          {this.state.searchShow &&
            !this.state.FilterTable &&
            searchPageCount > 1 && (
              <ReactPaginate
                forcePage={this.state.Spage}
                pageCount={searchPageCount}
                onPageChange={this.handlePageSearchClick}
                containerClassName="pagination"
                activeClassName="active"
              />
            )}

          {this.state.FilterTable && fltrPageCount > 1 && (
            <ReactPaginate
              forcePage={this.state.FltrPage}
              pageCount={fltrPageCount}
              onPageChange={this.handlePageFltrClick}
              containerClassName="pagination"
              activeClassName="active"
            />
          )}
        </Card>
      </div>
    );
  }
}

export default ExpiryReturns;
